export default "__VITE_ASSET__616e6dee__"